import { Trash2 } from "react-feather"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { useStrictCookies } from "~/utils/cookies"

type CookiesTableProps = {
  cookieName?: string
  showValue: boolean
}

export const CookiesTable: React.FC<CookiesTableProps> = ({
  cookieName,
  showValue,
}) => {
  const { t } = useTranslation("privacy")
  const [allCookies, , removeCookie] = useStrictCookies()

  const allCookieNames = Object.keys(allCookies)

  const cookies = cookieName
    ? allCookieNames.filter((c) => c.startsWith(cookieName))
    : allCookieNames

  const cookieDetails = cookies.map((key) => {
    const cookieValue = allCookies[key]

    return (
      <tr key={key}>
        <td>
          <code>{key}</code>
        </td>
        {showValue && (
          <td className="break-all">
            {typeof cookieValue === "string" || typeof cookieValue === "number"
              ? cookieValue
              : JSON.stringify(cookieValue)}
          </td>
        )}
        <td>
          <button
            className={clsx(
              "flex items-center justify-center",
              "h-12 w-12",
              "text-red-700 hover:text-red-600",
            )}
            onClick={() => removeCookie(key)}
            title={t("cookies.delete")}
            type="button"
          >
            <span className="sr-only">{t("cookies.delete")}</span>
            <Trash2 />
          </button>
        </td>
      </tr>
    )
  })

  return !cookieDetails.length ? (
    <p>{t("cookies.noCookiesInUse")}</p>
  ) : (
    <table className="w-full max-w-full">
      {showValue && (
        <thead>
          <tr>
            <th>{t("cookies.table.name")}</th>
            <th>{t("cookies.table.value")}</th>
            <th />
          </tr>
        </thead>
      )}
      <tbody>{cookieDetails}</tbody>
    </table>
  )
}
